var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-mybody1",attrs:{"id":"lookthree"}},[_c('a-row',[_c('a-col',{attrs:{"span":24}},[_c('div',{staticClass:"look_g"},[_c('div'),_vm._v("聯絡資料 ")]),_c('a-table',{staticStyle:{"width":"100%"},attrs:{"columns":_vm.columns,"data-source":_vm.columnsData,"rowKey":(record, index) => index,"pagination":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }